module.exports = __webpack_public_path__ + "img/004.8ac197cc.png";